export default __webpack_public_path__ + "img/img_joanna-943ab22328516a9afdb5c31cf9e0cc88.jpg";